import React from 'react';
import PropTypes from 'prop-types';

import { Group } from 'components/core/Page';
import { Modal, ModalBody, ModalTitle } from 'components/core/Modal';
import { H3, H4, Paragraph } from 'components/core/Typography';
import { vehicleUnitSizeOptions } from 'config/units';

export function VehicleUnitSizeModal({
	showing, onClose, unitSizes, segmentLabel, title
}) {
	return (
		<Modal
			segmentLabel={segmentLabel}
			showing={showing}
			onClose={onClose}
		>
			<ModalTitle>
				<H3 last size="medium">
					{title}
				</H3>
			</ModalTitle>
			<ModalBody>
				{unitSizes.map((unitSize) => (
					<Group key={unitSize.title}>
						<H4 size="small">
							{unitSize.title}
						</H4>
						<Paragraph>
							{unitSize.description}
						</Paragraph>
					</Group>
				))}
			</ModalBody>
		</Modal>
	);
}

VehicleUnitSizeModal.propTypes = {
	showing: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	unitSizes: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			description: PropTypes.string.isRequired
		}).isRequired
	),
	segmentLabel: PropTypes.string,
	title: PropTypes.string
};

VehicleUnitSizeModal.defaultProps = {
	unitSizes: vehicleUnitSizeOptions,
	segmentLabel: 'vehicle-unit-size',
	title: 'Unit Size Guide'
};

export default VehicleUnitSizeModal;
